export default function({router, to}) {
  // Get the first matched component.
  const [component] = router.getMatchedComponents({...to})

  if (component) {
    router.app.$nextTick(() => {
      // Start the page loading bar.
      if (component.loading !== false && router.app.$loading && router.app.$loading.start) {
        router.app.$loading.start()
      }

      // Set application layout.
      if (router.app.setLayout) {
        router.app.setLayout(component.layout || '')
      }

    })
  }
}
